import { render, staticRenderFns } from "./search-resume.vue?vue&type=template&id=9522a15c&"
import script from "./search-resume.vue?vue&type=script&lang=js&"
export * from "./search-resume.vue?vue&type=script&lang=js&"
import style0 from "./search-resume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports